// Chest assets + trove sounds (shared by the map chest and the Hoard dock).
export const CHEST_IMG = "/hoard-chest.webp";
export const CHEST_OPEN_IMG = "/hoard-chest-open.webp";
export const CHEST_VIDEO = "/hoard-chest-open.mp4";
export const CHEST_VIDEO_WEBM = "/hoard-chest-open.webm";
export const CHEST_CLOSE_VIDEO = "/hoard-chest-close.mp4";
export const CHEST_CLOSE_VIDEO_WEBM = "/hoard-chest-close.webm";
export const CHEST_SOUND = "/sounds/chest-open.mp3";
export const CHEST_CLOSE_SOUND = "/sounds/chest-close.mp3";

export const troveMuted = () => localStorage.getItem("wall_trove_muted") === "1";
const play = (src, vol) => { try { const a = new Audio(src); a.volume = vol; a.play().catch(() => {}); } catch { /* no audio */ } };
// Chest creak + chime every time the lid opens — never over a voice clip, never when muted (music keeps playing underneath).
export const playChestSound = () => {
  if (troveMuted() || window.__wallVoicePlaying) return;
  play(CHEST_SOUND, 0.7);
};
// Heavy lid shutting when the Hoard is minimized — every time, unless muted or a voice clip is playing.
export const playChestClose = () => {
  if (troveMuted() || window.__wallVoicePlaying) return;
  play(CHEST_CLOSE_SOUND, 0.6);
};
